import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconController32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconController32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 8H9a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2m0-2c1.306 0 2.418.835 2.83 2H25a1 1 0 1 1 0 2h-9.17A3 3 0 0 1 13 12H9a3 3 0 1 1 0-6zm13 10a1 1 0 0 1-1 1h-4.17A3 3 0 0 1 18 19h-4a3 3 0 0 1-2.83-2H7a1 1 0 1 1 0-2h4.17A3 3 0 0 1 14 13h4c1.306 0 2.418.835 2.83 2H25a1 1 0 0 1 1 1m-12 1a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2zm4 6a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1M7 24h9.17A3 3 0 0 0 19 26h4a3 3 0 1 0 0-6h-4a3 3 0 0 0-2.83 2H7a1 1 0 1 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconController32);
